import _ from "lodash";
import axios from "axios";

import {
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  SET_ERROR,
  SET_IS_AUTHENTICATED,
  SET_ROUTER_STATE,
  SET_SCREEN_SIZE,
  SET_SESSION_PREFERENCES,
  SET_USER,
  SET_USER_METADATA,
  SET_USER_METADATA_FETCHED,
  START_ASYNC_ACTION,
  STOP_ASYNC_ACTION
} from "./types";
import Auth from "./../helpers/Authentication/Auth";

const LAPTOP_SCREEN_SIZE = 1025;

export const asyncAction = (action, actionId, errorDispatch = null) => {
  return async dispatch => {
    try {
      dispatch({ type: START_ASYNC_ACTION, payload: actionId });
      await action(dispatch);
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error });
      if (typeof errorDispatch === "function") {
        errorDispatch(dispatch);
      }
    } finally {
      dispatch({ type: STOP_ASYNC_ACTION, payload: actionId });
    }
  };
};

export const createAsyncAction = (creatorHandler, errorDispatch = null) => {
  const id = _.uniqueId("ACTION_");
  const bindedAsyncAction = _.bind(asyncAction, null, _, id, errorDispatch);
  const action = creatorHandler(bindedAsyncAction);

  return Object.assign(action, { id });
};

export const setError = error => ({ type: SET_ERROR, payload: error });

export const setRouterState = transition => ({ type: SET_ROUTER_STATE, payload: transition });

export const setUser = user => ({ type: SET_USER, payload: user });

export const setUserMetadata = userMetadata => ({ type: SET_USER_METADATA, payload: userMetadata });

export const setUserMetadataFetched = () => ({ type: SET_USER_METADATA_FETCHED });

export const updateUserMetadata = (userMetadata, userId) => {
  return async dispatch => {
    try {
      const accessToken = Auth.getAccessToken();
      new Auth(accessToken).updateUserMetadata(userId, userMetadata, () => dispatch({ type: SET_USER_METADATA, payload: userMetadata }));
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error });
    }
  };
};

export const setIsAuthenticated = isAuthenticated => ({ type: SET_IS_AUTHENTICATED, payload: isAuthenticated });

export const changeLanguage = (language, userMetadata, userId) => {
  return async dispatch => {
    try {
      const accessToken = Auth.getAccessToken();
      new Auth(accessToken).updateUserMetadata(userId, { language }, () => {
        dispatch({ type: SET_USER_METADATA, payload: { ...userMetadata, language } });
      });
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error });
    }
  };
};

export const setAccessToken = accessToken => {
  return async dispatch => {
    try {
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } catch (error) {
      dispatch({ type: SET_ERROR, payload: error });
    }
  };
};

export const receiveLogin = user => ({ type: LOGIN_SUCCESS, payload: { isAuthenticated: true, user } });

export const receiveError = message => ({
  type: LOGIN_FAILURE,
  payload: { isAsyncActionInProgress: false, isAuthenticated: false, errorMessage: message }
});

export const setScreenSize = screenSize => ({
  type: SET_SCREEN_SIZE,
  payload: { isMobile: screenSize <= LAPTOP_SCREEN_SIZE, isLaptop: screenSize > LAPTOP_SCREEN_SIZE }
});

export const setSessionPreferences = preferences => ({ type: SET_SESSION_PREFERENCES, payload: preferences });



// WEBPACK FOOTER //
// ./src/actions/appActions.js